import { z, isoZ } from 'my-zod'

export const customAssetFamilyModel = z.object({
  id: z.number().int(),
  name: z
    .string({
      invalid_type_error: 'Name is required',
      required_error: 'Name is required'
    })
    .min(1, 'Name must contain at least 1 character')
    .max(45, 'Name must contain at most 45 characters'),
  assetClassId: z.number().int(),
  seatingCapacity: z
    .number({
      invalid_type_error: 'Seating Capacity is required',
      required_error: 'Seating Capacity is required'
    })
    .int()
    .min(1, 'Seating Capacity must be more than or equal to 1'),
  imageUrl: z.string().url('Image is required').max(512),
  description: z.string().max(500, 'Description must contain at most 500 characters').nullable(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type customAssetFamilyModel = z.infer<typeof customAssetFamilyModel>
